import Vue from 'vue'
import Vuex from 'vuex'

import searchEnginePage from './modules/searchEnginePage.js'
import locationForm from './modules/locationForm.js'
import documentForm from './modules/documentForm.js'
import wiki from './modules/wiki.js'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    searchEnginePage,
    locationForm,
    documentForm,
    wiki
  },
  state: {
    errors_info: [],
    authenticated: false,
    userProfile: false,
    progressLinear: false,
    globalSearch: '',
    loginSignupForm: false,
    // algolia index and graphql queries that are allowed for unlogger user.
    unloggedUserQueries: [],
    unloggedUserIndex: ['articles'],
    dialogContactUs: false
  },
  mutations: {
    addError (state, payload) {
      if (!state.errors_info.includes(payload)) {
        state.errors_info.push(payload)
      }
    },
    resetErrors (state, payload) {
      state.errors_info = []
    },
    setProgressLinear (state, payload) {
      state.progressLinear = payload
    },
    setAuthState (state, payload) {
      state.authenticated = payload
    },
    setUserInfos (state, payload) {
      state.userProfile = payload
    },
    setDemoUserInfos (state, payload) {
      state.user_demo = payload
    },
    setGlobalSearch (state, payload) {
      state.globalSearch = payload
    },
    setLoginSignupForm (state, payload) {
      state.loginSignupForm = payload
    },
    setViewDialogContactUs (state, payload) {
      state.dialogContactUs = payload
    }
  },
  actions: {
    async isAuthenticated ({ commit, state, dispatch }) {
      var isAuthenticated = new Date().getTime() < localStorage.getItem('expiresIn')
      await commit(
        'setAuthState',
        (!!localStorage.getItem('id_token') && isAuthenticated === true))
      return isAuthenticated
    },
    async completeAuthentication ({ commit, state, dispatch }) {
      // get user from authentication system
      if (state.authenticated) {
        const user = localStorage.getItem('profile')
        const userJson = JSON.parse(user)
        commit('setUserInfos', userJson)

        // live chat set user name and email to the chatbox
        if (process.env.NODE_ENV === 'production') {
          window.LiveChatWidget.call('set_customer_name', userJson.name)
          window.LiveChatWidget.call('set_customer_email', userJson.email)
        }
      }
    }
  }
})

export default store
